import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm } from 'redux-form';
import { PERFIL_ADMIN, getAdminEmpresa, getFiscalEmbarque, getGestorEmpresa, getOperadorEmpresa } from '../../security/securityContext';
import Titulo from '../comum/Titulo';
import buscarAgrugadoDisponibilidadeVeiculo from '../../actions/disponibilidade-veiculo/buscarAgrugadoDisponibilidadeVeiculo';
import Autorizacao from '../../security/Autorizacao';
import buscarVeiculos from '../../actions/veiculo/buscarVeiculos'
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import AgrupadoCalendarioDisponibilidadeVeiculo from './AgrupadoCalendarioDisponibilidadeVeiculo';
import selecionarAgrupadoDisponibilidadeVeiculo from '../../actions/disponibilidade-veiculo/selecionarAgrupadoDisponibilidadeVeiculo';
import selecionarDisponibilidadeVeiculo from '../../actions/disponibilidade-veiculo/selecionarDisponibilidadeVeiculo';
import moment from 'moment';
import ModalCalendario from '../ModalCalendario';


export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
        <div className="row cabecalho-desktop">
            <div className="col">Veículo</div>
            <div className="col">Ativo/Inativo</div>
            <div className="col ml-md-2">Assentos</div>
            <div className="col-sm-2 d-flex justify-content-center">Ações</div>
        </div>
    </div>
);


export class PainelGerenciarAgrupadoCalendarioDisponibilidadeVeiculo extends Component {
    constructor(props) {
        super(props)

        this.state = {
            combinedEventsData: []
        }
    }

    componentDidMount() {
        this.props.selecionarAgrupadoDisponibilidadeVeiculo(null);
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.props.buscarVeiculos(this.props.empresaSelecionada.id, null, null, null, false);
            this.props.buscarAgrugadoDisponibilidadeVeiculo(this.props.empresaSelecionada.id);
        }
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps)) {
            if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
                this.props.buscarVeiculos(this.props.empresaSelecionada.id, null, null, null, false);
                this.props.buscarAgrugadoDisponibilidadeVeiculo(this.props.empresaSelecionada.id);
            }
        }
    }

    preencherModalCalendario(valor) {
        let bloqueios = [];
        let agendamentoViagem = [];
        let disponibilidadesVeiculo = [];

        const dv = valor.disponibilidadeVeiculo;
        if (dv && dv.length > 0) {
            const eventos = dv.map(it => {
                const bloqueioDisponibilidadeVeiculo = it.bloqueioDisponibilidadeVeiculo;
                if (bloqueioDisponibilidadeVeiculo && bloqueioDisponibilidadeVeiculo.length > 0) {
                    bloqueios = bloqueioDisponibilidadeVeiculo.map(b => {
                        return {
                            title: <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>,
                            start: moment(b.dataInicio).toDate(),
                            end: moment(b.dataFim).add(1, 'day').toDate(),
                            tipo: 'bloqueado',
                            legenda: 'bloqueado'
                        }
                    })
                }

                return {
                    title: <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>,
                    start: moment(it.dataInicio).toDate(),
                    end: moment(it.dataFim).add(1, 'day').toDate(),
                    tipo: 'disponivel',
                    legenda: 'disponivel'
                }

            })

            disponibilidadesVeiculo = [...eventos];
        }

        const ag = valor.agendamentoViagem;
        if (ag && ag.length > 0) {
            agendamentoViagem = ag.map(a => {
                return {
                    title: <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>,
                    start: moment(a.dataInicio).toDate(),
                    end: moment(a.dataFim).add(1, 'day').toDate(),
                    tipo: 'comAgendamento',
                    legenda: 'Com Agendamento'
                }
            })
        }


        const todosEventos = [...disponibilidadesVeiculo, ...bloqueios, ...agendamentoViagem];
        this.setState({
            combinedEventsData: todosEventos
        })
    }

    // eslint-disable-next-line class-methods-use-this
    exibirBotaoNovoCalendario() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id)]}>
                <div className="row col-md-12 mb-4">
                    <div className="row col-md-4">
                        <button className="btn btn-laranja" 
                        onClick={() => {
                            this.props.selecionarDisponibilidadeVeiculo(null);
                            this.props.history.push('/painel-cadastro-calendario-disponibilidade-veiculo?tipo=agrupado')
                        }}>
                            Criar Calendário
                        </button>
                    </div>
                </div>
            </Autorizacao>)
    }

    exibirTabelaCalendariosAgrupadoDisponibilidadeVeiculo() {
        return (<div className="col-12 conteudo-internas">
            {this.props.agrupadosDisponibilidadesVeiculo.length != 0 && <CabecalhoTabela />}
            <div className="lista-table">
                {this.exibirCalendariosAgrupadorDisponibilidadesVeiculo()}
            </div>
        </div>
        )
    }

    exibirCalendariosAgrupadorDisponibilidadesVeiculo() {
        if (this.props.agrupadosDisponibilidadesVeiculo.length == 0) {
            return <div>Nenhum Calendário disponível.</div>;
        }

        return this.props.agrupadosDisponibilidadesVeiculo.map(it =>
            <AgrupadoCalendarioDisponibilidadeVeiculo  
                key={`agrupados-disponibilidade-veiculo-${it.veiculo.id}`} 
                agrupadoDisponibilidadesVeiculo={it}
                preencherModalCalendario={this.preencherModalCalendario.bind(this)} /> );
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id)]}>
                <div>
                    <Titulo texto="Calendário Disponibilidade Veículo" urlRetorno="/gestao-empresa" />
                    {this.exibirBotaoNovoCalendario()}
                    {this.exibirTabelaCalendariosAgrupadoDisponibilidadeVeiculo()}
                </div>
                <ModalCalendario combinedEventsData={this.state.combinedEventsData} />
                </Autorizacao>
        )

    }
}

export const mapStateToProps = state => (
    {
        veiculos: state.veiculos.veiculos,
        empresaSelecionada: state.empresaSelecionada,
        agrupadosDisponibilidadesVeiculo: state.agrupadosDisponibilidadesVeiculo
    });

export default withRouter(connect(mapStateToProps, {
    buscarVeiculos,
    selecionarDisponibilidadeVeiculo,
    buscarAgrugadoDisponibilidadeVeiculo,
    selecionarAgrupadoDisponibilidadeVeiculo
})(reduxForm({
    form: 'formularioAgrupadoCalendarioDisponibilidadeVeiculo'
})(PainelGerenciarAgrupadoCalendarioDisponibilidadeVeiculo)))
